export const MODULE = {
  careMoni: 'CAREMONI',
};
